const select = async function() {
    if ( !document.querySelector(".wpcf7-select") ) return;

    try {
        const CustomSelect = await (await import('../utils/custom-select')).default;
        const forms = document.querySelectorAll(".wpcf7-form");
        forms.forEach(form => {
            form.querySelectorAll(".wpcf7-select").forEach(select => {
                const customSelect = new CustomSelect(select, {
                    label: "Please select",
                    value: "none",
                    parent: form,
                    afterElement: '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" fill="none" viewBox="0 0 11 8"><path fill="#AE9967" d="m10.826.125-5.24 7.124L.346.125h10.48Z"/></svg>',
                })
            })
            
        })
    } catch (e) {}
}

export const init = select;